import { useTranslation } from 'react-i18next';
import tick from '../../Assets/images/Group 62.png';
import ProfileBuilderWrapper from '../../Components/pages/profileBuilder.Wrapper/ProfileBuilderWrapper';
import CompleteProfile from '../../Components/pages/CompleteProfile/CompleteProfile';

export function ProfileBuilderSeven() {
  const [t] = useTranslation();

  return (
    <ProfileBuilderWrapper
      titleMain={t('profile.builder.thanks')}
      component={<img src={tick} alt="tick" className="py-5" />}
      filled
      progress={100}
    >
      <CompleteProfile />
    </ProfileBuilderWrapper>
  );
}
